<template>
  <div>
    <h1>Unauthorized action</h1>
    <p>Sorry, you do not have permission to view this page.</p>
    <p>If you think this is a mistake, please contact an administrator.</p>
  </div>
</template>

<script>
export default {
  name: 'error-404',
};
</script>
